
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Margin, Size } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Margin`}</h1>
<p>{`Low level component used to wrap other elements with margin.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Margin } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<div style={{ border: '1px solid red', display: 'inline-block' }}>
  <Margin>
    <div style={{ background: 'green', height: 100, width: 100 }} />
  </Margin>
</div>`} component={Margin} mdxType="Playground">
  <div style={{
        border: '1px solid red',
        display: 'inline-block'
      }}>
    <Margin mdxType="Margin">
      <div style={{
            background: 'green',
            height: 100,
            width: 100
          }} />
    </Margin>
  </div>
</Playground>
<p>{`You can also pass an object to specify the margin on each side. You can see below that the two `}<inlineCode parentName="p">{`Margin`}</inlineCode>{` components, when placed side by side, merge their margins. This is not the case with the `}<inlineCode parentName="p">{`Padding`}</inlineCode>{` component. Inspect the code below to see the effect.`}</p>
<Playground __position={1} __code={`<>
  <Margin size={{
    top: Size.LARGE,
    bottom: Size.LARGE,
    left: Size.EXTRA_SMALL,
  }}>
    <div style={{ background: 'green', height: 100, width: 100 }} />
  </Margin>
  <Margin size={{
    top: Size.LARGE,
    bottom: Size.EXTRA_SMALL,
    left: Size.MASSIVE,
  }}>
    <div style={{ background: 'green', height: 100, width: 100 }} />
  </Margin>
</>`} mdxType="Playground">
  <>
    <Margin size={{
          top: Size.LARGE,
          bottom: Size.LARGE,
          left: Size.EXTRA_SMALL
        }} mdxType="Margin">
      <div style={{
            background: 'green',
            height: 100,
            width: 100
          }} />
    </Margin>
    <Margin size={{
          top: Size.LARGE,
          bottom: Size.EXTRA_SMALL,
          left: Size.MASSIVE
        }} mdxType="Margin">
      <div style={{
            background: 'green',
            height: 100,
            width: 100
          }} />
    </Margin>
  </>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;